<template>
  <div>
    <!-- Modal Android/Chrome/PC -->
    <transition name="fade">
      <div v-if="showInstallModal && !isIOS" class="modal-overlay">
        <div class="install-modal">
          <button @click="closeInstall" class="close-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          <div class="modal-content">
            <div class="logo-section">
              <img src="/logo.png" alt="App Logo" class="app-logo-large">
            </div>

            <h2 class="modal-title">Get Our App</h2>
            <p class="modal-subtitle">Install for the best experience</p>

            <div class="features-list">
              <div class="feature-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"></path>
                  <polyline points="10 16 16 10 10 16"></polyline>
                </svg>
                <span>Quick access from home screen</span>
              </div>
              <div class="feature-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
                <span>Works offline - never lose access</span>
              </div>
              <div class="feature-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                </svg>
                <span>Lightning-fast performance</span>
              </div>
            </div>

            <div class="modal-actions">
              <button @click="installPWA" class="btn btn-primary">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="8 17 12 21 16 17"></polyline>
                  <line x1="12" y1="1" x2="12" y2="9"></line>
                </svg>
                Install Now
              </button>
              <button @click="closeInstall" class="btn btn-secondary">
                Maybe Later
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal iOS : instructions manuelles -->
    <transition name="fade">
      <div v-if="showInstallModal && isIOS" class="modal-overlay">
        <div class="install-modal">
          <button @click="closeInstall" class="close-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

          <div class="modal-content">
            <div class="logo-section">
              <img src="/logo.png" alt="App Logo" class="app-logo-large">
            </div>

            <h2 class="modal-title">Install on iPhone</h2>
            <p class="modal-subtitle">Add the app to your home screen in 3 steps</p>

            <div class="ios-steps">
              <div class="ios-step">
                <div class="step-number">1</div>
                <div class="step-text">
                  Tap the
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2">
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
                    <polyline points="16 6 12 2 8 6"></polyline>
                    <line x1="12" y1="2" x2="12" y2="15"></line>
                  </svg>
                  <strong>Share</strong> button in Safari
                </div>
              </div>
              <div class="ios-step">
                <div class="step-number">2</div>
                <div class="step-text">
                  Scroll and tap <strong>"Add to Home Screen"</strong>
                </div>
              </div>
              <div class="ios-step">
                <div class="step-number">3</div>
                <div class="step-text">
                  Tap <strong>"Add"</strong> to confirm
                </div>
              </div>
            </div>

            <div class="modal-actions">
              <button @click="closeInstall" class="btn btn-primary">
                Got it!
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Snackbar mise à jour -->
    <transition name="slide-up">
      <div v-if="updateAvailable" class="update-snackbar">
        <div class="update-content">
          <div class="update-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21.5 2v6h-6"></path>
              <path d="M2.5 22v-6h6"></path>
              <path d="M2 11.5a10 10 0 0 1 18.8-4.3"></path>
              <path d="M22 12.5a10 10 0 0 1-18.8 4.2"></path>
            </svg>
          </div>
          <div class="update-text">
            <p class="update-title">Update Available</p>
            <p class="update-desc">A new version is ready to use</p>
          </div>
        </div>
        <div class="update-actions">
          <button @click="refreshApp" class="btn-update">Update</button>
          <button @click="dismissUpdate" class="btn-dismiss">Dismiss</button>
        </div>
      </div>
    </transition>

    <!-- Toast succès installation -->
    <transition name="slide-down">
      <div v-if="installSuccess" class="success-toast">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>App installed successfully!</span>
      </div>
    </transition>

    <!-- Badge offline -->
    <transition name="fade">
      <div v-if="isOffline" class="offline-indicator">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span>You're offline</span>
      </div>
    </transition>

    <!-- Bouton flottant : Android/PC avec deferredPrompt OU iOS -->
    <transition name="fade">
      <button
        v-if="!showInstallModal && canShowInstallBtn && !isAppInstalled()"
        @click="showInstallModal = true"
        class="floating-install-btn"
        title="Install our app"
      >
        <img src="/favicon.png" alt="App" class="floating-logo">
        <span class="install-label">Install App</span>
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PWAInstallPrompt',
  data() {
    return {
      deferredPrompt: null,
      showInstallModal: false,
      updateAvailable: false,
      installSuccess: false,
      registration: null,
      isOffline: !navigator.onLine,
      installDismissed: false,
      isIOS: false,
    }
  },
  computed: {
    canShowInstallBtn() {
      return this.deferredPrompt !== null || this.isIOS
    }
  },
  watch: {
    '$route' () {
      if (this.isRecommendedPage()) {
        this.showInstallModal = false
      }
    }
  },
  mounted() {
    this.detectIOS()
    this.initPWA()
    this.setupOfflineListener()
  },
  beforeDestroy() {
    window.removeEventListener('online', this.handleOnline)
    window.removeEventListener('offline', this.handleOffline)
  },
  methods: {
    detectIOS() {
      const ua = navigator.userAgent
      this.isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream

      // iOS : afficher modal après 5s (pas d'event beforeinstallprompt sur iOS)
      if (this.isIOS && !this.isAppInstalled()) {
        setTimeout(() => {
          if (!this.installDismissed && !this.isRecommendedPage()) {
            this.showInstallModal = true
          }
        }, 5000)
      }
    },

    isRecommendedPage() {
      return !!(this.$route && (
        this.$route.name === 'recommended_products' ||
        (this.$route.path || '').startsWith('/market_place/recommended/')
      ))
    },

    initPWA() {
      // Android / PC Chrome : event natif
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        this.deferredPrompt = e

        if (!this.isAppInstalled()) {
          setTimeout(() => {
            if (!this.installDismissed && !this.isRecommendedPage()) {
              this.showInstallModal = true
            }
          }, 5000)
        }
      })

      window.addEventListener('appinstalled', () => {
        this.showInstallModal = false
        this.installSuccess = true
        this.deferredPrompt = null
        setTimeout(() => {
          this.installSuccess = false
        }, 4000)
      })

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then((reg) => {
          this.registration = reg

          setInterval(() => {
            reg.update()
          }, 60 * 60 * 1000)

          if (reg.waiting) {
            this.updateAvailable = true
          }

          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  this.updateAvailable = true
                }
              })
            }
          })
        }).catch((err) => {
          console.error('Service Worker error:', err)
        })

        let refreshing = false
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return
          refreshing = true
          window.location.reload()
        })
      }
    },

    setupOfflineListener() {
      window.addEventListener('online', this.handleOnline)
      window.addEventListener('offline', this.handleOffline)
    },

    handleOnline() {
      this.isOffline = false
    },

    handleOffline() {
      this.isOffline = true
    },

    isAppInstalled() {
      return window.matchMedia('(display-mode: standalone)').matches ||
             window.navigator.standalone === true
    },

    async installPWA() {
      if (!this.deferredPrompt) return

      this.deferredPrompt.prompt()
      const { outcome } = await this.deferredPrompt.userChoice

      if (outcome === 'accepted') {
        this.showInstallModal = false
      }

      this.deferredPrompt = null
    },

    closeInstall() {
      this.showInstallModal = false
      this.installDismissed = true
    },

    refreshApp() {
      this.updateAvailable = false
      if (this.registration && this.registration.waiting) {
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      } else {
        window.location.reload()
      }
    },

    dismissUpdate() {
      this.updateAvailable = false
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

.slide-up-enter-active, .slide-up-leave-active,
.slide-down-enter-active, .slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-up-enter, .slide-up-leave-to { transform: translateY(100px); opacity: 0; }
.slide-down-enter, .slide-down-leave-to { transform: translateY(-100px); opacity: 0; }

.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.install-modal {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: modalSlideIn 0.3s ease;
}

@keyframes modalSlideIn {
  from { opacity: 0; transform: scale(0.95) translateY(-20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.close-btn {
  position: absolute;
  top: 16px; right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px; height: 36px;
  border-radius: 8px;
  transition: all 0.2s;
}
.close-btn:hover { color: #374151; background: #f3f4f6; }

.logo-section {
  text-align: center;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.app-logo-large {
  width: 100px; height: 100px;
  border-radius: 24px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  object-fit: contain;
}

.modal-title {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  text-align: center;
  margin: 0 0 8px 0;
}

.modal-subtitle {
  font-size: 15px;
  color: #6b7280;
  text-align: center;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.features-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 28px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #374151;
}
.feature-item svg { color: #3b82f6; flex-shrink: 0; }

/* iOS Steps */
.ios-steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 8px;
}

.ios-step {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
}

.step-number {
  width: 30px; height: 30px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}

.step-text {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
  width: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}
.btn-primary:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4); }

.btn-secondary { background: #f3f4f6; color: #374151; }
.btn-secondary:hover { background: #e5e7eb; }

/* Update Snackbar */
.update-snackbar {
  position: fixed;
  bottom: 24px; left: 24px;
  background: white;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  z-index: 1900;
  max-width: 420px;
}

.update-content { display: flex; align-items: center; gap: 12px; flex: 1; }
.update-icon { color: #0284c7; display: flex; align-items: center; flex-shrink: 0; }
.update-text { display: flex; flex-direction: column; gap: 2px; }
.update-title { font-weight: 600; font-size: 14px; color: #111827; margin: 0; }
.update-desc { font-size: 12px; color: #6b7280; margin: 0; }
.update-actions { display: flex; gap: 8px; }

.btn-update, .btn-dismiss {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}
.btn-update { background: #3b82f6; color: white; }
.btn-update:hover { background: #2563eb; }
.btn-dismiss { background: transparent; color: #6b7280; }
.btn-dismiss:hover { background: #f3f4f6; }

/* Success Toast */
.success-toast {
  position: fixed;
  bottom: 24px; left: 24px;
  background: #10b981;
  color: white;
  border-radius: 10px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 10px 30px rgba(16, 185, 129, 0.3);
  z-index: 1900;
}

/* Offline */
.offline-indicator {
  position: fixed;
  top: 16px; right: 16px;
  background: #f59e0b;
  color: white;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  z-index: 1800;
}

/* Floating button */
.floating-install-btn {
  position: fixed;
  bottom: 84px; right: 48px;
  background: white;
  border: none;
  border-radius: 50px;
  padding: 8px 16px 8px 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.3);
  transition: all 0.3s ease;
  z-index: 1500;
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  font-family: inherit;
}
.floating-install-btn:hover { transform: translateY(-4px); box-shadow: 0 12px 32px rgba(59, 130, 246, 0.4); }

.floating-logo { width: 36px; height: 36px; border-radius: 8px; object-fit: contain; }

.install-label {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 640px) {
  .install-modal { padding: 32px 20px; border-radius: 16px; }
  .modal-title { font-size: 22px; }
  .app-logo-large { width: 80px; height: 80px; }
  .update-snackbar { left: 12px; right: 12px; bottom: 16px; flex-direction: column; align-items: flex-start; }
  .update-actions { width: 100%; justify-content: flex-end; }
  .success-toast, .offline-indicator { left: 12px; right: 12px; }
  .floating-install-btn { bottom: 92px; right: 24px; }
}
</style>